var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.909,
    height: 20.946,
    viewBox: "0 0 20.909 20.946",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone-call",
    d: "M14.085,4.7A4.627,4.627,0,0,1,17.74,8.357M14.085,1a8.328,8.328,0,0,1,7.357,7.348m-.925,7.385v2.776A1.851,1.851,0,0,1,18.5,20.359a18.314,18.314,0,0,1-7.986-2.841A18.045,18.045,0,0,1,4.96,11.966,18.313,18.313,0,0,1,2.119,3.943,1.851,1.851,0,0,1,3.961,1.925H6.737A1.851,1.851,0,0,1,8.588,3.517a11.882,11.882,0,0,0,.648,2.6A1.851,1.851,0,0,1,8.819,8.07L7.644,9.245A14.806,14.806,0,0,0,13.2,14.8l1.175-1.175a1.851,1.851,0,0,1,1.953-.416,11.882,11.882,0,0,0,2.6.648,1.851,1.851,0,0,1,1.592,1.879Z",
    transform: "translate(-1.361 -0.172)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.39e11d8ff3c250db94c6361b3d06ccbf.svg";
export { ForwardRef as ReactComponent };